export default "__VITE_ASSET__CFD1O50n__"